import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      closeButton
      offset="92px"
      gap={12}
      toastOptions={{
        style: {
          background: "#033F99",
          color: "#FFFFFF",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          borderRadius: "0.75rem",
          boxShadow: "0 10px 25px -5px rgba(3, 63, 153, 0.35), 0 8px 10px -6px rgba(3, 63, 153, 0.35)",
        },
        classNames: {
          toast:
            "group toast font-sans text-sm font-medium shadow-xl !bg-[#033F99] !text-white !border-white/15",
          title: "!text-white font-semibold text-sm",
          description: "!text-white/85 text-xs",
          actionButton:
            "bg-white text-[#033F99] font-semibold hover:bg-white/90 rounded-lg px-3 py-1.5 text-xs shadow",
          cancelButton:
            "bg-white/10 text-white hover:bg-white/20 rounded-lg px-3 py-1.5 text-xs",
          closeButton:
            "!bg-red-500 hover:!bg-red-600 !text-white !border !border-white/30 !rounded-full transition-colors shadow-sm",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
